<template>
  <div id="app" :style="{ height: height + 'px' }">
    <easy-player
      live
      muted
      autoplay
      :video-url="url"
      style="width: 100%; height: 100%"
      ref="video"
    />
  </div>
</template>

<script>
import EasyPlayer from '@easydarwin/easyplayer'
export default {
  components: { EasyPlayer },
  data() {
    return {
      url: '',
      height: '',
    }
  },
  mounted() {
    if (location.href.indexOf('#reloaded') == -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
    this.$nextTick(() => {
      this.url = this.GetQueryString('url')
      this.height = this.GetQueryString('height')
      console.log('视频地址', this.url)
    })
  },
  beforeDestory() {
    this.$refs.video.destroyPlayer()
  },
  methods: {
    GetQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
  },
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
}
</style>
